import pick from 'lodash/pick'
import victimInfoApi from '@/api/victimInfo.js'
import { victimInfo as VictimInfoModel } from '@/api/models'
import { mergeUserContext } from '@/store/helpers.js'

const victimInfoState = {
    personVictimInfo: [],
    victimInfoCreateError: false
}

const getters = {
    getPersonVictimInfo: (state) => state.personVictimInfo,
    getVictimInfoCreateError: (state) => state.victimInfoCreateError
}

const actions = {
    async getPersonVictimInfo ({ commit, rootState }, payload) {
        try {
            commit('SET_PERSON_VICTIM_INFO', [])

            payload = mergeUserContext(payload, rootState)
            const response = await victimInfoApi.getVictimInfo(payload)
            if (response.status !== 200) {
                throw response.body.error
            }

            commit('SET_PERSON_VICTIM_INFO', response.body)
        } catch (error) {
            commit('SET_PERSON_VICTIM_INFO', [])
        }
    },

    async bulkUpdatePersonVictimInfo ({ commit, rootState }, payload) {
        try {
            payload = mergeUserContext(payload, rootState)
            payload.victimInfo = payload.victimInfo.map((victim) => pick(victim, Object.keys(VictimInfoModel)))

            const response = await victimInfoApi.updateVictimInfo(payload)
            if (response.status !== 200) {
                throw response.body.error
            }

            commit('SET_VICTIM_INFO_CREATE_ERROR', false)
            commit('SET_PERSON_VICTIM_INFO', response.body.victimInfo)
        } catch (error) {
            commit('SET_VICTIM_INFO_CREATE_ERROR', true)
            commit('SET_PERSON_VICTIM_INFO', [])
        }
    }
}

const mutations = {
    SET_PERSON_VICTIM_INFO (state, payload) {
        state.personVictimInfo = payload
    },

    SET_VICTIM_INFO_CREATE_ERROR (state, payload) {
        state.victimInfoCreateError = payload
    }
}

export default {
    state: victimInfoState,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/victimInfo.js